(() => {
 let turnstileReady;
 function loadVerification(){
  if(window.turnstile)return Promise.resolve(window.turnstile);
  if(!turnstileReady)turnstileReady=new Promise((resolve,reject)=>{
   const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;
   script.onload=()=>window.turnstile?resolve(window.turnstile):reject(Error('verification_failed'));
   script.onerror=()=>{script.remove();turnstileReady=null;reject(Error('verification_failed'));};document.head.append(script);
  });
  return turnstileReady;
 }
 if(customElements.get('eaura-stock-alert'))return;
 class StockAlert extends HTMLElement {
  connectedCallback(){
   if(this.bound)return;
   this.bound=true;
   try{this.variants=JSON.parse(this.querySelector('script[type="application/json"]').textContent);}catch{return;}
   this.form=this.querySelector('form');this.open=this.querySelector('[data-stock-open]');
   this.status=this.querySelector('[data-stock-status]');this.submit=this.querySelector('[type="submit"]');
   this.onVariant=e=>{const v=this.variants.find(v=>String(v.id)===String(e.detail?.variant?.id));this.select(v?.id);};
   document.addEventListener('variant:changed',this.onVariant);
   this.open.onclick=()=>{this.form.hidden=false;this.open.setAttribute('aria-expanded','true');this.form.elements.email.focus();this.verification();};
   this.querySelector('[data-stock-close]').onclick=()=>{this.form.hidden=true;this.open.setAttribute('aria-expanded','false');this.open.focus();};
   this.open.setAttribute('aria-expanded','false');
   this.form.onsubmit=e=>this.send(e);
   this.select(this.dataset.variant);
  }
  disconnectedCallback(){document.removeEventListener('variant:changed',this.onVariant);this.bound=false;if(this.widget!==undefined){window.turnstile?.remove(this.widget);this.widget=undefined;}}
  async verification(){
   if(this.widget!==undefined||!this.dataset.sitekey)return;
   try{const api=await loadVerification();if(!this.isConnected||this.widget!==undefined)return;this.widget=api.render(this.querySelector('[data-stock-verification]'),{sitekey:this.dataset.sitekey,action:'stock-alert',theme:'light'});}
   catch{this.status.textContent='Verification could not load. Please close this form and try again.';}
  }
  select(id){
   this.variant=this.variants.find(v=>String(v.id)===String(id));
   this.hidden=!this.variant||this.variant.available!==false;
   this.form.hidden=true;this.open.setAttribute('aria-expanded','false');this.status.textContent='';
   this.querySelector('[data-stock-option]').textContent=this.variant?.title||'';
  }
  async send(e){
   e.preventDefault();if(this.sending||!this.form.reportValidity()||!this.variant||this.variant.available)return;
   // No endpoint is supplied until staging integration is complete.
   if(!this.dataset.endpoint){this.status.textContent='Stock alerts are not enabled yet.';return;}
   const endpoint=new URL(this.dataset.endpoint,location.origin);
   if(endpoint.origin!==location.origin||!endpoint.pathname.startsWith('/apps/'))return;
   const turnstileToken=this.widget===undefined?'':window.turnstile?.getResponse(this.widget);
   if(!turnstileToken){this.status.textContent='Please complete the verification first.';return;}
   const variantId=String(this.variant.id);
   this.sending=true;this.submit.disabled=true;this.status.textContent='Saving your request…';
   try{
    const response=await fetch(endpoint.href,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({turnstileToken,variantId,handle:this.dataset.handle,email:this.form.elements.email.value,requestedAlert:this.form.elements.requestedAlert.checked}),signal:AbortSignal.timeout(15000)});
    const result=await response.json();
    if(!response.ok)throw Error(result.error||'request_failed');
    if(result.accepted!==true)throw Error('not_accepted');
    if(String(this.variant?.id)===variantId){this.status.textContent='Your request is saved. We’ll email you when this option is available.';this.form.reset();}
   }catch(error){if(String(this.variant?.id)===variantId){const messages=['Please try again later','Unable to check this product; please try again','Verification failed','Please complete the verification','Stock alerts are not enabled yet','This option is available now; refresh the product page','Unable to save your request; please try again','Invalid request'];this.status.textContent=messages.includes(error.message)?error.message:'We couldn’t confirm your request. Please try again.';}}
   finally{if(this.widget!==undefined)window.turnstile?.reset(this.widget);this.sending=false;this.submit.disabled=false;}
  }
 }
 customElements.define('eaura-stock-alert',StockAlert);
})();
